import React, { Fragment } from 'react'
import { Grid, Icon, Card } from 'semantic-ui-react'
import {
  CONTROLLER as CONTROLLER_ROUTE,
  PLAY_SELECT as PLAY_SELECT_ROUTE
} from './routes'
import { MainContext } from './State'
import bump from '../../images/bump.png'
import football from '../../images/football.png'
import PropTypes from 'prop-types'

const Header = ({ history, location: { state } }) => {
  const ordinals = {
    1: 'st',
    2: 'nd',
    3: 'rd',
    4: 'th'
  }
  return (
    <MainContext.Consumer>
      {({
        onCancel,
        gameData: {
          id,
          team1,
          team2,
          state: { quarter, scores, down, yardsLeft, play, possession }
        }
      }) => (
        <Fragment>
          <Grid.Row
            style={{
              padding: 0
            }}
          >
            <img src={bump} />
            <h5
              style={{
                background: 'black',
                color: 'white',
                width: '100%',
                margin: 0
              }}
            >
              {quarter + ordinals[quarter]} Quarter
            </h5>
          </Grid.Row>
          <Grid.Row
            stretched
            columns={3}
            style={{
              backgroundColor: 'black',
              color: 'white'
            }}
          >
            <Grid.Column textAlign="center">
              <Grid.Row>
                <Grid.Column
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <div style={{ marginRight: 20 }}>
                    <h3>{team1.abbreviated}</h3>
                  </div>
                  <div style={{ marginRight: 5 }}>
                    <h3>{scores[0]}</h3>
                  </div>
                  <div>
                    {possession === 0 && <img src={football} width={15} />}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <Icon name="window minimize" size="large" color="orange" />
                  <Icon name="window minimize" size="large" />
                  <Icon name="window minimize" size="large" />
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <h1>
                {down + ordinals[down]}
                &nbsp; & {yardsLeft}
              </h1>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <Grid.Row>
                <Grid.Column
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <div style={{ marginRight: 20 }}>
                    <h3>{team2.abbreviated}</h3>
                  </div>
                  <div style={{ marginRight: 5 }}>
                    <h3>{scores[1]}</h3>
                  </div>
                  <div>
                    {possession === 1 && <img src={football} width={15} />}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <Icon name="window minimize" size="large" color="orange" />
                  <Icon name="window minimize" size="large" />
                  <Icon name="window minimize" size="large" />
                </Grid.Column>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            stretched
            columns={3}
            style={{
              backgroundColor: 'black',
              color: 'white',
              margin: 0
            }}
          >
            <Grid.Column textAlign="center">
              <h4>Last Play:</h4>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <h4
                style={{
                  color: 'limegreen'
                }}
              >
                {play.text}
              </h4>
            </Grid.Column>
            <Grid.Column textAlign="center" />
          </Grid.Row>
          {history.location.pathname !== CONTROLLER_ROUTE.format(id) && (
            <Grid.Row
              style={{
                padding: 0
              }}
            >
              <Card
                fluid
                style={{
                  backgroundColor: 'crimson',
                  color: 'white'
                }}
                onClick={() => {
                  onCancel()
                  history.replace(CONTROLLER_ROUTE.format(id))
                }}
              >
                <Card.Content>
                  <b>CANCEL</b>
                </Card.Content>
              </Card>
            </Grid.Row>
          )}
          {state ? (
            <Fragment>
              {state.play && (
                <Grid.Row
                  style={{
                    padding: 0
                  }}
                >
                  <Card
                    fluid
                    style={{
                      backgroundColor: 'orangered',
                      color: 'white'
                    }}
                    onClick={() =>
                      history.replace(PLAY_SELECT_ROUTE.format(id), {
                        ...state
                      })
                    }
                  >
                    <Card.Content>
                      <b>Play: {state.play.text}</b>
                    </Card.Content>
                  </Card>
                </Grid.Row>
              )}
            </Fragment>
          ) : null}
        </Fragment>
      )}
    </MainContext.Consumer>
  )
}

Header.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Controller/Header.jsx